const SUMMARY_OF_DEALS_PERIODS = {
  month: 'Month Year',
  quarter: 'Quarter Year',
  year: 'Year',
};

Object.freeze(SUMMARY_OF_DEALS_PERIODS);

export { SUMMARY_OF_DEALS_PERIODS };
